import GraphQLClientService from '../../services/GraphQLClientService';
import { TopographyEntity } from "../../ResponseObjects/Schemas/TopographyEntity";
import { useProgressStore } from '../../store/progressStore';
import { Stage, GeometryType } from '../../constants/progress';

export default async function fetchTopographyData(minX, minY, maxX, maxY, crs) {
  // Validate parameters
  const geometryType = GeometryType.TOPOGRAPHY;
  const updateProgress = useProgressStore.getState().updateProgress;
  //console.log(minX,minY,maxX,maxY)
  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing boundingbox",
      error:"All boundary parameters (minX, minY, maxX, maxY) are required"
    })
    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }
  updateProgress(geometryType,{
    stage: Stage.QUERY,
    message:'Fetching data from server',
    progress: 25,
    error: null

  })

  const query = `query GetTopographyPoints {
    topographyAsPointList(
      minLat: ${maxY}
      minLon:${maxX}
      maxLat: ${minY}
      maxLon: ${minX}
      outputCRS: ${crs}
      revitProtocol: true
    ) {
        metadata {
              dgmLevel
              queryBoundsArea
              origin {
                elevation
                latitude
                longitude
                x
                y
              }
              elevationRange {
                maximum
                minimum
                range
                unit
              }
            }
      points {
        x
        y
        z
      }
    }
  }`;

  const client = new GraphQLClientService();

  try {
    // const { callApi, isAuthenticated } = useGraphQLApi();
    // console.log(callApi);
    const response = await client.executeQueryAsync(query);
    if(response == "TimedOUT")
    {
      updateProgress(geometryType,{
                  stage: Stage.TIMEDOUT,
                  message: 'Timed OUT',
                  progress: 0
              
                })
      return null;

    }
    else{
        if ( response.data.topographyAsPointList) {
              updateProgress(geometryType,{
                  stage: Stage.QUERYSTAGE,
                  message: 'Fetched data from the server',
                  progress: 50,
                  fetched: response.data.topographyAsPointList.length
                })
          const topographyEntities = TopographyEntity.fromResponse(response, crs);
              updateProgress(geometryType,{
              stage: Stage.PROCESSINGSTAGE,
              message: 'Processed fetched data from the server',
              progress: 50,
              processed: topographyEntities.length
            })
        return topographyEntities;
      } else {
            updateProgress(geometryType,{
            stage: Stage.NULL,
            message:'No data returned or an error occurred.',
            error:'No data returned or an error occurred.'
          })
        console.log('No data returned or an error occurred.');
        return null;
      }
    }
  } 
  
  catch (error) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message:'Error during GraphQL request:',
      error: error
    })
    console.error('Error during GraphQL request:', error);
    throw error; 
  }
}